
define('text!modules/reporting/campaigns/reachFrequency/templates/chartLayout.html',[],function () { return '<strand-drawer class="w-chart-drawer" opened-height="345" closed-height="5" {{#chartShown}}expanded{{/chartShown}} opened-label="Hide Chart" closed-label="Show Chart">\n  <div class="w-box w-Chart rf-chart-panel"></div>\n</strand-drawer>';});

